import { api } from '@/services'
import Vue from 'vue'

const actions = {
  async changeStatus({ commit, dispatch }, body) {
    if (!body?.appointment_id) {
      dispatch('showErrorMessage', Vue.i18n.translate('appointment.messages.appointmentNotFound'), { root: true })
      return
    }

    await api
      .post('/admin/appointment/changeStatus', body)
      .then(() => {
        commit('closeAllModals', null, { root: true })
        dispatch('fetchAppointmentAsAdmin', body.appointment_id, { root: true })
      })
      .catch(({ data }) => {
        dispatch('showErrorMessage', data ? data.message : 'Erro ao atualizar status', { root: true })
      })
  },
}

export default {
  namespaced: true,
  actions,
}
